<template>
	<svg class="icon icon-search" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path d="M13.742,12.991,9.526,8.775a5.306,5.306,0,1,0-.745.745L13,13.736a.523.523,0,0,0,.74,0l.005,0A.554.554,0,0,0,13.742,12.991Zm-8.3-3.328A4.229,4.229,0,1,1,9.671,5.434,4.229,4.229,0,0,1,5.442,9.663Z"/></svg>
</template>

<script>
export default {
	name: 'IconSearch'
}
</script>
